import "./Payments.css"; // Optional: for styling

const Payment = () => {
  return (
    <div className="payment-banner">
      <h2 className="Payment-title">Secure Payments, Your Way</h2>
      <p>
        We support all major payment methods via <strong>Razorpay</strong> –
        fast, safe, and flexible.
      </p>
      <div className="payment-icons">
        <img
          src="https://myfoodsolution.com/public/assets/payment/razorpay.png"
          alt="Razorpay"
        />
        <img
          src="https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/upi-icon.png"
          alt="UPI"
        />
        <img
          src="https://uxwing.com/wp-content/themes/uxwing/download/e-commerce-currency-shopping/credit-card-color-icon.png"
          alt="Credit/Debit Card"
        />
        <img
          src="https://uxwing.com/wp-content/themes/uxwing/download/banking-finance/net-banking-icon.png"
          alt="Net Banking"
        />
        <img
          src="https://www.svgrepo.com/show/298772/wallet.svg"
          alt="Wallets"
        />
        <img
          src="https://uxwing.com/wp-content/themes/uxwing/download/banking-finance/emi-paid-icon.png"
          alt="EMI"
        />
        <a href="https://razorpay.me/@ootygo" className="Pay-Btn">
          🔒 Pay Now to Book Instantly
        </a>
      </div>
    </div>
  );
};

export default Payment;
